import { Button, ButtonProps } from '@mui/material'
import { normalizedName } from '../../../components/entities/CompanyName'
import React from 'react'
import { CompanyEntity } from 'types/CompanyEntity'

export const NewIssueQuickButton = ({
    company,
    ...buttonProps
}: {
    company: Pick<CompanyEntity, 'name'> & ButtonProps
}) => {
    if (!company) return null
    return (
        <Button variant='contained' color='primary' size='small' {...buttonProps}>
            Ny emission för {normalizedName(company.name)}
        </Button>
    )
}
